import type { FC } from "react"

import { usePaymentTermMutation } from "../hooks/usePaymentTermMutation"
import type { PaymentTermsSchemaFormValues } from "../schemas/PaymentTermsSchema"
import { serializePaymentTermsForm } from "../utils/paymentTerms"

import PaymentTermContainer from "./PaymentTermContainer"

import { type PaymentTermCreateFailure } from "@/graphql/codegen/graphql"
import { NotificationType } from "@/schemas/notification"
import { useNotificationsStore } from "@/stores/useNotificationsStore"

const CreatePaymentTermsContainer: FC = () => {
  const { enqueueNotification } = useNotificationsStore()
  const { createPaymentTerm } = usePaymentTermMutation()

  const onSubmit = async (data: PaymentTermsSchemaFormValues) => {
    const formattedData = serializePaymentTermsForm(data)
    const { error, data: result } = await createPaymentTerm({
      input: formattedData,
    })
    if (error || (result?.paymentTerm?.create as PaymentTermCreateFailure)?.error) {
      enqueueNotification({
        type: NotificationType.Error,
        content: <p>Payment term creation failed</p>,
      })
    } else {
      enqueueNotification({
        type: NotificationType.Success,
        content: <p>Payment term successfully created</p>,
      })
    }
  }

  return <PaymentTermContainer onSubmit={onSubmit} />
}

export default CreatePaymentTermsContainer
